// BlogPage.js
import React from 'react';
import {BentoGridDemo} from "./bentodemo"; 
const BlogPage = () => {
  return (
    <div>
      <div className='bg-red-100'>
      <div className="pt-20">
    <BentoGridDemo />
    </div>
    </div>
  
    </div>
  );
};

export default BlogPage;
